import React from 'react';
import TeamSlider from '../../components/slider/TeamSlider';
import { Link } from 'react-router-dom';
const Team = () => {

    return (
        <>
          {/*Team One Start*/}
          <section  style={{backgroundColor: '#EAF7FF',margin: '0px 40px',borderRadius: '30px'}}   className="team-one">
                <div className="container">
                <div className="team-one__top">
                    <div className="section-title text-left">
                    <div className="section-title__tagline-box">
                            <h1 style={{color: '#006FB4',fontSize: '42px',fontWeight: 'bold',fontFamily: 'Montserrat'}}>Testimonials</h1>
                    </div>
                    <p style={{color: '#2A2A2A',fontSize: '18px',fontFamily: 'Montserrat'}}>
                              We provide everything from Drayage to Trans-loading to Cross Docking.
                    </p>
                    <button  style={{width:'140px',height:'50px'}} className='thm-btn mt-4' >
                        View All 
                    <i className="icon-angle-left"></i>
                    </button>
                    </div>
                    <div className="team-one__nav">
                    <div className="swiper-button-next1">
                        <i className="icon-arrow-left" />
                    </div>
                    <div className="swiper-button-prev1">
                        <i className="icon-arrow-right" />
                    </div>
                    </div>
                </div>
                <div className="team-one__bottom">
                    
                    <TeamSlider/>

                </div>
                </div>
            </section>
            {/*Team One End*/}  
        </>
    );
}

export default Team;
